class TMv_WAA_PageMenus {

	constructor(element)
	{
		this.element = element;

		if(this.element) {
			this.element.addEventListener('keydown', this.keyHandler.bind(this));
		}

	}


	keyHandler(event) {

		let arrow_keys = ['ArrowDown','ArrowUp','ArrowRight','ArrowLeft'];

		if(arrow_keys.includes(event.code))
		{
			let active_element = document.activeElement;

			// Check that we are currently in a menu
			let parent_li = active_element.parentElement;
			if(active_element.tagName === 'A' && parent_li.tagName === 'LI')
			{

				// Never let it scroll
				event.preventDefault();

				// LEVEL 1 MENU
				if(parent_li.parentElement.classList.contains('TMv_PageMenus'))
				{
					// Needs to hop over hidden top-level menus, which are used for mobile
					if(event.code === 'ArrowLeft')
					{
						// Find one until we hit the end OR we find another l_1
						let next_parent_li = parent_li.previousElementSibling;
						while (next_parent_li !== null && !next_parent_li.classList.contains('nav_1'))
						{
							next_parent_li = next_parent_li.previousElementSibling;
						}
						if(next_parent_li)
						{
							next_parent_li.firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowRight')
					{
						// Find one until we hit the end OR we find another l_1
						let next_parent_li = parent_li.nextElementSibling;
						while (next_parent_li !== null && !next_parent_li.classList.contains('nav_1'))
						{
							next_parent_li = next_parent_li.nextElementSibling;
						}
						if(next_parent_li)
						{
							next_parent_li.firstElementChild.focus();
						}

					}
					else if(event.code === 'ArrowDown')
					{
						// Check if there is a submenu
						if(parent_li.querySelector('ul'))
						{
							// Find the first element and focus on it
							parent_li.querySelector('li.l_3 a').focus();
						}
					}
				}

				// LEVEL 3 MENU - up/down moves in nav, right jumps over if it exists
				else if(parent_li.classList.contains('l_3'))
				{
					if(event.code === 'ArrowRight')
					{
						if(parent_li.nextElementSibling)
						{
							parent_li.nextElementSibling.firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowLeft')
					{
						if(parent_li.previousElementSibling)
						{
							parent_li.previousElementSibling.firstElementChild.focus();
						}

					}
					else if(event.code === 'ArrowUp')
					{
						// Find the first element and focus on it
						parent_li.closest('.l_2').firstElementChild.focus();
					}

				}
			}
		}

	}
}
